import React from 'react';
import PropTypes from 'prop-types';
import parse from 'url-parse';
import TocBar from './TocBar';
import VersionSelector from './VersionSelector';
import LanguageSelector from './LanguageSelector';
import BetaBadge from './BetaBadge';
import styles from './styles.module.styl';

const HeaderWrapper = ({ meta }) => {
  const showVersionSelector = !!meta.versioning;
  const showLanguageSelector = !!meta.languages;
  const showMetadataContainer = showVersionSelector || showLanguageSelector;

  return (
    <div className={styles.headerWrapper}>
      {meta.toc ?
        <TocBar
          title={meta.title}
          titles={meta.titles.filter(t => t.level === 2 || t.level === 3)}
          showBetaBadge={!!meta.beta}
        /> :
        <h1 className={styles.title}>
          {meta.title}
          {meta.beta && <BetaBadge />}
        </h1>
      }
      {showMetadataContainer &&
        <div className={styles.metaContainer}>
          {showVersionSelector && <VersionSelector meta={meta} />}
          {showLanguageSelector && (
            <LanguageSelector
              languages={meta.languages}
              pathname={parse(meta.url).pathname}
            />
          )}
        </div>
      }
    </div>
  );
};

HeaderWrapper.propTypes = {
  meta: PropTypes.shape({
    toc: PropTypes.bool,
    title: PropTypes.string.isRequired,
    titles: PropTypes.arrayOf(PropTypes.shape({
      content: PropTypes.string.isRequired,
      anchor: PropTypes.string.isRequired,
      level: PropTypes.number.isRequired
    })).isRequired,
    versioning: PropTypes.object,
    languages: PropTypes.array
  }).isRequired
};

export default HeaderWrapper;
